export const isFunction = arg => typeof arg === 'function';